import { Component } from '@angular/core';
import { SiteContextSelectorComponent, IconComponent } from '@spartacus/storefront';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-efa-site-context-selector',
    templateUrl: './efa-site-context-selector.component.html',
    imports: [IconComponent, AsyncPipe]
})
export class EfaSiteContextSelectorComponent extends SiteContextSelectorComponent {}
